export enum VisitsAndScheduledTasksTableType {
  VisitReports = 'Visit reports',
  PeriodReports = 'Period reports',
  DigestReports = 'Digest reports',
}
